var _defs, _circle, _circle2, _g, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusTpcLuminousBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 820",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "blue"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gold"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFB51B",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB51B",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 625,
    r: 420,
    fill: "url(#blue)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 210,
    r: 330,
    fill: "url(#gold)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#087CFF",
    transform: "translate(128 765)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 420,
    ry: 260,
    strokeOpacity: 0.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 350,
    ry: 215,
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 285,
    ry: 170,
    strokeOpacity: 0.12,
    strokeDasharray: "4 9"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 667,
    r: 3.5,
    fill: "#FF2775"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusTpcLuminousBackground);
export default __webpack_public_path__ + "static/media/andus-tpc-luminous-background.317c72e49b9c82e7db9d8c1200419bad.svg";
export { ForwardRef as ReactComponent };